import { render } from "./MessageInput.vue?vue&type=template&id=017d11d0&scoped=true&ts=true"
import script from "./MessageInput.vue?vue&type=script&lang=ts"
export * from "./MessageInput.vue?vue&type=script&lang=ts"

import "./MessageInput.vue?vue&type=style&index=0&id=017d11d0&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017d11d0"]])

export default __exports__